import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n'; // Import i18n setup
import "@fontsource/noto-sans";
import { WebSocketProvider } from './websocket_context';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <I18nextProvider i18n={i18n}>
  <BrowserRouter>
    <WebSocketProvider> {/* Wrap App with WebSocketProvider */}
      <App />
    </WebSocketProvider>
  </BrowserRouter>
</I18nextProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

// module.exports = {
//   theme: {
//     screens: { minimum width
//       sm: '640px', mobile
//       md: '768px',  ipad air portrait
//       lg: '1024px', 1024px x 768   ipad pro portrait
//       xl: '1280px',  1280 x 800   my lap
//       '2xl': '1536px',  1536 x 864  desktop
//     },
//   },
// };